<input
  #input
  type="text"
  [id]="inputId()"
  [class]="cssClass()"
  [class.is-invalid]="invalid()"
  [class.abx-address-autocomplete__input--ready]="ready()"
  [value]="value()"
  [disabled]="disabled()"
  [placeholder]="placeholder()"
  [attr.maxlength]="maxlength()"
  [attr.aria-required]="required() ? 'true' : null"
  [attr.aria-invalid]="invalid() ? 'true' : null"
  [attr.aria-describedby]="invalid() ? describedBy() : null"
  [attr.autocomplete]="autocompleteAttr()"
  [attr.role]="ready() ? 'combobox' : null"
  [attr.aria-autocomplete]="ready() ? 'list' : null"
  [attr.aria-haspopup]="ready() ? 'listbox' : null"
  [attr.aria-expanded]="ready() ? (expanded() ? 'true' : 'false') : null"
  [attr.aria-controls]="ready() ? listboxId() : null"
  autocapitalize="words"
  (input)="handleInput($event)"
  (focus)="handleFocus()"
  (blur)="handleBlur()"
  (keydown)="handleKeydown($event)" />
